import React from 'react';
import { FaAngleRight } from "react-icons/fa";
import { Link } from 'react-router-dom';
import './banner.css';

const Banner = () => {
    return (
        <div className='banner'>
            <div className='banner-content pl-12 lg:pl-28'>
                <h1 className='text-6xl font-extrabold'><span className='text-7xl'>Salma</span> <br />
                    Home-Made Food <br />
                    <span className='bg-yellow-400 pl-1 pr-6 py-2'>Services</span></h1>
                <div className='mt-6'>
                    <Link to={'/foods'}><button className="btn gap-2">
                        Order Now <FaAngleRight/>
                    </button></Link>
                </div>
            </div>
        </div>
    );
};

export default Banner;